import api from "../../services/api";
import {EMPLOYEE_LOG} from "../../config/routesApi";

export default async function accessLog (data) {
    return await api.request({
        url: `${EMPLOYEE_LOG.url}/${data.id}?trigger=${data.trigger}`,
        method: `${EMPLOYEE_LOG.method}`
    })
};
